/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { SvgIcon } from '@mui/material';

export function LinkedInIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props}>
      <path d="M19,0 L5,0 C2.239,0 0,2.239 0,5 L0,19 C0,21.761 2.239,24 5,24 L19,24 C21.762,24 24,21.761 24,19 L24,5 C24,2.239 21.762,0 19,0 Z M8,19 L5,19 L5,8 L8,8 L8,19 Z M6.5,6.732 C5.534,6.732 4.75,5.942 4.75,4.968 C4.75,3.994 5.534,3.204 6.5,3.204 C7.466,3.204 8.25,3.994 8.25,4.968 C8.25,5.942 7.467,6.732 6.5,6.732 Z M20,19 L17,19 L17,13.396 C17,10.028 13,10.283 13,13.396 L13,19 L10,19 L10,8 L13,8 L13,9.765 C14.396,7.179 20,6.988 20,12.241 L20,19 Z" />
    </SvgIcon>
  );
}
